const tw = {
  message: {
    Save_cmd: '存檔',
    Close_cmd: '關閉視窗',
    Del_cmd: '刪除',
    Query_cmd: '查詢',
    Send_cmd: '確認送出',
    Sign_in: '登入',
    Sign_Out: '登出',
    Lang_txt: '語言',
    Confirm_txt: '確定',
    Load_txt: '載入中',
    Error_txt: '錯誤',
    Success_txt: '成功',
    Warning_txt: '警告',
    Info_txt: '消息',
    Upload_txt: '點擊上傳',
    Back_txt: '上一步',
    Next_txt: '下一步',
    Keep_txt: '資料暫存',
    Check_txt: '資料檢查',
    Report_txt: '報表',
    Excel_txt: '試算表',
    CSV_txt: 'CSV檔',
    Edit_txt: '編輯',
    Calc_txt: '計算',
    Anno_txt: '最新公告',
    Cancel_txt: '取消',
    DateTime_txt: '選擇日期時間',
    New_txt: '新增',
    Contacts_txt: '聯絡我們',
    NCUT_txt: '勤益科大',
    ID_txt: '帳號',
    PassW_txt: '密碼',
    ValiC_txt: '驗證碼',

  }
}
export default tw
